import { EngagementHttpService } from './../http/engagement-http.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BranchHttpService } from '../http/branch-http.service';

@Injectable({
    providedIn: 'root',
})
export class ContactHttpResolverService implements Resolve<any> {
    constructor(private engagementHttpService: EngagementHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.engagementHttpService.getAllContacts();
    }
}

@Injectable({
    providedIn: 'root',
})
export class SurveyHttpResolverService implements Resolve<any> {
    constructor(private engagementHttpService: EngagementHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.engagementHttpService.getAllSurvey();
    }
}

@Injectable({
    providedIn: 'root',
})
export class ReviewHttpResolverService implements Resolve<any> {
    constructor(private engagementHttpService: EngagementHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.engagementHttpService.getAllReviews();
    }
}
